import * as XLSX from "xlsx";
import toast from "react-hot-toast";
import { formatDate } from "./mixin";

export type AssignmentSubmissionExportRow = {
  name?: string | null;
  email?: string | null;
  mobile_number?: string | null;
  alternate_number?: string | null;
  batch_course_code?: string | null;
  batch_name?: string | null;
  assignment_title?: string | null;
  status?: string | null;
  submitted_at?: string | Date | null;
  file_url?: string | null;
  reviewed_at?: string | Date | null;
  score?: number | null;
  result_pdf_url?: string | null;
};

function formatExportDateTime(value?: string | Date | null) {
  if (!value) return "";
  const formatted = formatDate(String(value), "DD MMM YYYY hh:mm A");
  return formatted === "?" ? "" : formatted;
}

function sanitizeFilenamePart(value: string) {
  return value
    .replace(/[\\/:*?"<>|]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/** Excel export for Manage Assignments — same XLSX approach as Orders */
export function exportAssignmentSubmissionsExcel(
  rows: AssignmentSubmissionExportRow[],
  filename = "Submission List.xlsx",
) {
  const dataRows = rows.map((row) => ({
    "Student Name": row.name || "",
    Email: row.email || "",
    "WhatsApp Number": row.mobile_number || "",
    "Alternate Number": row.alternate_number || "",
    "Batch Code": row.batch_course_code || "",
    "Batch Name": row.batch_name || "",
    "Assignment Title": row.assignment_title || "",
    Status: row.status || "Unattempted",
    "Submitted At": formatExportDateTime(row.submitted_at),
    "File URL": row.file_url || "",
    "Reviewed At": formatExportDateTime(row.reviewed_at),
    Score: row.score ?? "",
    "Result PDF URL": row.result_pdf_url || "",
  }));

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(dataRows);
  if (dataRows.length) {
    worksheet["!cols"] = Object.keys(dataRows[0]).map((header) => ({
      wch: Math.max(header.length + 2, 18),
    }));
  }
  XLSX.utils.book_append_sheet(workbook, worksheet, "Submissions");
  const safeName = sanitizeFilenamePart(filename.replace(/\.xlsx$/i, ""));
  XLSX.writeFile(workbook, `${safeName || "Submission List"}.xlsx`);
  toast.success(`Exported ${dataRows.length} rows`);
}
